import styled from 'styled-components'
import measures from 'globals/measures'
import colors from 'globals/colors'

interface SubmitButtonWrapperProps {
  alignSelf?: string,
  justifyContent?: string,
  noBottomMargin?: boolean
}

export const SubmitButtonWrapper = styled.div<SubmitButtonWrapperProps>`
  min-width: ${measures.submitButtonMinWidth}px;
  align-self: ${(props) => props.alignSelf || 'center'};
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: ${(props) => props.justifyContent || 'flex-end'};
  //padding-bottom: ${(props) => props.noBottomMargin ? 0 : measures.submitButtonMargin}px;
`

export const Info = styled.div`
  text-align: center;
  color: ${colors.steelGrey};
  font-size: 12px;
  line-height: 24px;
  margin-top: 2px;
  
  @media(max-width: ${measures.mobileThreshold}px) {
    display: none;
  }
`
